class TeamMembersArchive {
  constructor(element) {
    this.element = element;
    this.buttons = this.element.querySelectorAll('[data-element="team-members-archive-member-button"]');
    this.closeButtons = this.element.querySelectorAll('[data-element="team-members-archive-member-close-button"]');
    this.bios = this.element.querySelectorAll('[data-element="team-members-archive-member-bio"]');
    this.modals = this.element.querySelectorAll('[data-element="team-members-archive-member-modal"]');
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this, button));
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.onCloseButtonClick.bind(this, button));
    });

    this.bindMatchMedia();
  }

  onButtonClick(button) {
    const bio = button.closest('[data-element="team-members-archive-member"]').querySelector('[data-element="team-members-archive-member-bio"]');
    this.showBio(bio);
  }

  onCloseButtonClick(button) {
    const bio = button.closest('[data-element="team-members-archive-member-bio"]');
    this.hideBio(bio);
  }

  hideBio(bio) {
    bio.classList.remove('team-members-archive__member-bio--show');
  }

  showBio(bio) {
    bio.classList.add('team-members-archive__member-bio--show');
    bio.scrollIntoView();
  }

  bindMatchMedia() {
    const width = 800;
    const widthMatch = window.matchMedia(`(min-width: ${width}px)`);

    widthMatch.addEventListener('change', (matchMedia) => {
      // If it matches then we are large screen
      if (matchMedia.matches) {
        this.bios.forEach((bio) => {
          this.hideBio(bio);
        });
      } else {
        document.body.style.overflow = 'visible';
        this.modals.forEach((modal) => {
          modal.classList.remove('is-open');
        });
      }
    });
  }
}

const teamMembersArchive = {
  init() {
    const teamMembersArchiveElements = document.querySelectorAll('[data-module="team-members-archive"]');

    if (teamMembersArchiveElements && teamMembersArchiveElements.length) {
      teamMembersArchiveElements.forEach((element) => {
        const teamMembersArchiveElement = new TeamMembersArchive(element);
        teamMembersArchiveElement.init();
      });
    }
  },
};

export default teamMembersArchive;
